export default __webpack_public_path__ + "static/auth-9d35bc0a7d85a8dd41869ad598941c75.jpg";